import Login from "./AuthPages/Login/Index";
import ForgotPassword from "./AuthPages/ForgotPassword";
import OtpVerification from "./AuthPages/OTPVerification/OTPverification";
import ResetPassword from "./AuthPages/ResetPassword";
import Accounting from "./SideTabPages/Accounting";
import ContentPage from "./SideTabPages/ContentPage";
import Dashboard from "./SideTabPages/Dashboard";
import Faq from "./SideTabPages/Faq-management";
import GannWheel from "./SideTabPages/GannWheel";
import Homepage from "./SideTabPages/Homepage";
import ManageTutorial from "./SideTabPages/ManageTutorial";
import MasterPlanet from "./SideTabPages/MasterPlanet";
import SecondaryPlanet from "./SideTabPages/SecondaryPlanet";
import StockEchange from "./SideTabPages/StockExchange";
import SystemAdmin from "./SideTabPages/SystemAdmin";
import TimeZone from "./SideTabPages/TimeZone";
import User from "./SideTabPages/User";
import Subscription from "./SideTabPages/subscription";
import HeliocentricConfig from "./SideTabPages/Helioconfig";

export const ROUTES = {
  LOGIN: "/login",
  OTP_VERIFICATION: "/otp-verification",
  FORGOT_PASSWORD: "/forgot-password/:type?",
  RESET_PASSWORD: "/reset-password",
};

export const PRIVATE_ROUTES = {
  DASHBOARD: "/dashboard",
  GANN_WHEEL: "/gann-wheel",
  PROPERTY: "/property",
  HOMEPAGE: "/homepage",
  CUSTOMER: "/customer",
  SUBSCRIPTION: "/subscription",
  STOCK_EXCHANGE: "/stock-exchange",
  MASTER_PLANET: "/master-planet",
  SECONDARY_PLANET: "/secondary-planet",
  MANAGE_TUTORIAL: "/manage-tutorial",
  ACCOUNTING: "/accounting",
  TIMEZONE: "/timezone",
  CONTENT_PAGE: "/content-page",
  FAQ_MANAGEMENT: "/faq-management",
  MANAGE_USERS: "/manage-users",
  HELIOCONFIG: "/helioconfig"
};

export const routes = [
  { path: ROUTES.LOGIN, component: <Login /> },
  { path: ROUTES.OTP_VERIFICATION, component: <OtpVerification /> },
  { path: ROUTES.FORGOT_PASSWORD, component: <ForgotPassword /> },
  { path: ROUTES.RESET_PASSWORD, component: <ResetPassword /> },
];

export const privateRoutes = [
  { path: PRIVATE_ROUTES.DASHBOARD, component: <Dashboard />, key: "dashboard" },
  { path: PRIVATE_ROUTES.GANN_WHEEL, component: <GannWheel />, key: "gennWheel" },
  { path: PRIVATE_ROUTES.PROPERTY, component: <GannWheel />, key: "gennWheel" },
  { path: PRIVATE_ROUTES.HOMEPAGE, component: <Homepage />, key: "home" },
  { path: PRIVATE_ROUTES.CUSTOMER, component: <User />, key: "user" },
  { path: PRIVATE_ROUTES.SUBSCRIPTION, component: <Subscription />, key: "subscription" },
  { path: PRIVATE_ROUTES.STOCK_EXCHANGE, component: <StockEchange />, key: "marketStock" },
  { path: PRIVATE_ROUTES.MASTER_PLANET, component: <MasterPlanet />, isSecured: true, key: "masterPlanet" },
  { path: PRIVATE_ROUTES.SECONDARY_PLANET, component: <SecondaryPlanet />, isSecured: true, key: "secondaryPlanet" },
  { path: PRIVATE_ROUTES.MANAGE_TUTORIAL, component: <ManageTutorial />, key: "tutorial" },
  { path: PRIVATE_ROUTES.ACCOUNTING, component: <Accounting />, key: "accounting" },
  { path: PRIVATE_ROUTES.TIMEZONE, component: <TimeZone />, key: "timezone" },
  { path: PRIVATE_ROUTES.CONTENT_PAGE, component: <ContentPage />, key: "content" },
  { path: PRIVATE_ROUTES.FAQ_MANAGEMENT, component: <Faq />, key: "faq" },
  { path: PRIVATE_ROUTES.MANAGE_USERS, component: <SystemAdmin />, key: "subAdmin" },
  { path: PRIVATE_ROUTES.HELIOCONFIG, component: <HeliocentricConfig />, key: "helioconfig" },
];
